(() => {
  const initializeHopeBundleSelectors = (scope = document) => {
    const selectors = scope.querySelectorAll(
      '[data-hope-bundle-selector]:not([data-hope-bundle-ready])'
    );

    selectors.forEach((selector) => {
      selector.setAttribute('data-hope-bundle-ready', 'true');

      const productForm = selector.closest('product-form');
      const form = productForm?.querySelector('form');

      if (!productForm || !form) return;

      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');

      const singleButton = selector.querySelector(
        '[data-hope-bundle-type="single"]'
      );

      const bundleButton = selector.querySelector(
        '[data-hope-bundle-type="bundle"]'
      );

      const singleVariantId = selector.dataset.singleVariantId;
      const bundleVariantId = selector.dataset.bundleVariantId;
      const sectionId = selector.dataset.sectionId;

      if (
        !variantInput ||
        !quantityInput ||
        !singleButton ||
        !bundleButton ||
        !singleVariantId ||
        !bundleVariantId
      ) {
        return;
      }

      let selectedDeal = 'single';

      const setActiveDeal = (deal) => {
        selectedDeal = deal;

        const singleActive = deal === 'single';
        const bundleActive = deal === 'bundle';

        singleButton.classList.toggle('is-active', singleActive);
        singleButton.setAttribute(
          'aria-pressed',
          String(singleActive)
        );

        bundleButton.classList.toggle('is-active', bundleActive);
        bundleButton.setAttribute(
          'aria-pressed',
          String(bundleActive)
        );
      };

      const switchMobileGalleryImage = (deal) => {
        if (!sectionId) return;

        const gallery = document.getElementById(
          `Media-Gallery-${sectionId}`
        );

        if (!gallery) return;

        const thumbnails = Array.from(
          gallery.querySelectorAll('[data-media-thumb]')
        );

        if (!thumbnails.length) return;

        const targetThumbnail =
          deal === 'bundle'
            ? thumbnails[thumbnails.length - 1]
            : thumbnails[0];

        targetThumbnail.click();
      };

      const selectSingleProduct = () => {
        variantInput.value = singleVariantId;
        quantityInput.value = 1;

        setActiveDeal('single');
        switchMobileGalleryImage('single');
      };

      const selectBundleProduct = () => {
        variantInput.value = bundleVariantId;
        quantityInput.value = 1;

        setActiveDeal('bundle');
        switchMobileGalleryImage('bundle');
      };

      singleButton.addEventListener('click', selectSingleProduct);
      bundleButton.addEventListener('click', selectBundleProduct);

      /*
       * Direkt vor dem Absenden wird noch einmal sichergestellt,
       * dass Shopify die richtige Variante und Menge erhält.
       */
      form.addEventListener(
        'submit',
        () => {
          variantInput.value =
            selectedDeal === 'bundle'
              ? bundleVariantId
              : singleVariantId;

          quantityInput.value = 1;
        },
        true
      );

      selectSingleProduct();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeHopeBundleSelectors();
    });
  } else {
    initializeHopeBundleSelectors();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeHopeBundleSelectors(event.target);
  });
})();